import React, { useEffect } from 'react'
import Logo from '../ui/Logo'
import { useTranslation } from 'react-i18next'
import { adminPageLinks } from '../../constants/data';
import { NavLink } from 'react-router-dom';
import { handleLogout } from '../../utils/data';
import { IoIosLogOut } from 'react-icons/io';
import { useDispatch } from 'react-redux';
import { fetchSetting } from '../../features/admin/settingSlice';
import { AppDispatch } from '../../store';

const MainMenu = ({onClose}:{onClose:React.Dispatch<boolean>}) => {
        const dispatch = useDispatch<AppDispatch>();
        useEffect(() => {
            dispatch(fetchSetting());
        }, [dispatch]);
    const { t, i18n } = useTranslation();
    return (
        <div className=' bg-darkColor overflow-x-hidden h-full text-white xs:flex flex-col '>
            <div className=' flex items-center border-b   gap-5 px-5 py-5  border-grayColor'>
                <h3 className=' text-xl font-semibold xs:hidden lg:block text-nowrap'>{t("dashboard")}</h3>
                <div className=' xs:w-14 sm:w-20'>
                    <Logo color={'white'} />
                </div>
            </div>
            <div className='w-full xs:px-2 sm:px-5 md:px-2 lg:px-5 mt-3'>
                <ul >
                    {adminPageLinks.map((link, index) => (
                        <li key={index} className='mb-2'>
                            <NavLink
                                to={link.link}
                                onClick={()=>onClose(false)}
                                end
                                className={({ isActive }) =>
                                    `flex  items-center md:justify-start xs:justify-center text-sm gap-2 hover:shadow-md px-2 py-3 rounded-xl transition-all duration-500 hover:bg-grayColor ${isActive ? 'shadow-md bg-gradient-to-t from-gray-600 to-textSecond' : ''
                                    }`
                                }
                            >
                                <p className='xs: text-sm sm:text-lg'>{link.icon}</p>
                                <p className=' xs:hidden md:block  '>{i18n.language === "ar" ? link.title_ar : link.title_en}</p>
                            </NavLink>
                        </li>
                    ))}
                </ul>
                <div className=''>
                    <button
                        onClick={() => handleLogout()}
                        className={
                            `flex text-nowrap items-center md:justify-start xs:justify-center  xs:text-sm gap-2 w-full hover:shadow-md text-base px-2 py-3 rounded-xl transition-all duration-500 bg-gradient-to-tr to-red-600 from-red-700`}>
                        <p className='xs: text-sm sm:text-lg'><IoIosLogOut /></p>
                        <p className=' xs:hidden md:block  '>{t("logout")}</p>
                    </button>
                </div>

            </div>
        </div>
    )
}

export default MainMenu